import type { FC, HTMLAttributes } from 'react';

import { useModifiers } from '../../../../styles/hooks/useModifiers';

import styles from './ProgressBar.module.css';

export interface ProgressBarProps extends HTMLAttributes<HTMLDivElement> {
  max: number;
  value: number;
}

export const ProgressBar: FC<ProgressBarProps> = ({ max, value, className = '' }) => {
  const mods = useModifiers(styles, 'progressBarContainer', {}, { withBaseClass: true, extraClassName: className });
  const transformPercent = max > 0 ? Math.min(0, (value / max) * 100 - 100) : -100;

  return (
    <div className={mods}>
      <div className={styles.progressBar}>
        <div className={styles.progressBar__progress} style={{ transform: `translateX(${transformPercent}%)` }} />
      </div>
    </div>
  );
};
